import { create } from "zustand";
import { getMenusByUser } from "../../../core/services";
export const useMenuStore = create((set, get) => ({
    menus: null,
    isLoading: false,
    error: null,
    hydrated: false,
    lastFetchedToken: null,
    fetchMenus: async (accessToken) => {
        const state = get();
        // Lewati fetch hanya jika: sudah ter-hydrate DAN token yang dipakai SAMA
        // (artinya user yang sama, menu masih valid).
        // Jika token berbeda (login user baru), selalu re-fetch.
        if (state.hydrated && accessToken && state.lastFetchedToken === accessToken)
            return;
        set({ isLoading: true, error: null });
        try {
            const menus = await getMenusByUser();
            set({ menus, isLoading: false, hydrated: true, lastFetchedToken: accessToken ?? null });
        }
        catch (err) {
            set({ error: err, isLoading: false });
        }
    },
    clearMenus: () => set({ menus: null, hydrated: false, lastFetchedToken: null }),
}));
